import React, { PureComponent } from 'react';

import { translate } from '../utils';
import { is768Query } from '~/core/scripts/mediaquery-helper';

function getTicks(ticks = []) {
  if (!ticks.length) {
    return []
  }

  if (is768Query() || ticks.length === 1) {
    return ticks;
  }

  // for smaller screens we only want to display first, middle, last values
  return ticks.length % 2 === 0 ?
    [ticks[0], ticks[ticks.length - 1]] :
    [ticks[0], ticks[~~(ticks.length / 2)], ticks[ticks.length - 1]];
}

function getTextAnchor(i, nodes) {
  if (is768Query()) {
    return 'center';
  }

  if (i === 0) {
    return 'start';
  }

  if (i === nodes.length - 1) {
    return 'end';
  }
}

function getDx(i, nodes) {
  if (is768Query()) {
    return 0;
  }

  switch (i) {
    case 0:
      return '-0.25em';
    case nodes.length - 1:
      return '0.25em';
    default:
      return 0;
  }
}

class XAxis extends PureComponent {
  render() {
    const { margin, width, height, ticks, x, drawTickLines } = this.props;
    const cleanTicks = getTicks(ticks);

    return (
      <g className="chart__xaxis chart__axis" transform={translate(0, height - margin.bottom + 0.5)}>
        <line className="domain" stroke="currentColor" x1={margin.left} y1="0" x2={width - margin.right} y2="0" />
        {cleanTicks.map((d, i, nodes) => (
          <g className="tick" transform={translate(~~x(d.value) + 0.5, 0)} key={`xaxis__${d.value}`} textAnchor={getTextAnchor(i, nodes)}>
            {drawTickLines && <line stroke="currentColor" y2="6" />}
            <text fill="currentColor" x={0} y="9" dy="0.71em" dx={getDx(i, nodes)}>{d.label}</text>
          </g>
        ))}
      </g>
    );
  }
}

export default XAxis;
